import { commonFilter } from './filter';

const pageId = '26024';

export default {
  pageName: 'Ads Overview',
  pageId,
  pagePath: '/opinion/AdCreatives/Overview',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
